(function () {
  var data = window.ezTradeExclusiveData || {};
  var block = document.getElementById('tradeExclusiveBlock');
  if (!block) return;

  // ─── Hydrate hidden form fields from Liquid-injected data ─────────
  var productField = document.getElementById('trade-product-field');
  var skuField = document.getElementById('trade-sku-field');

  if (productField) productField.value = (data.productTitle || '') + ' — ' + (data.productUrl || '');
  if (skuField) skuField.value = data.sku || '';

  // ─── Toggle reservation form ──────────────────────────────────────
  var toggleBtn = document.getElementById('tradeFormToggleBtn');
  var formWrap  = document.getElementById('tradeFormWrap');

  if (toggleBtn && formWrap) {
    toggleBtn.addEventListener('click', function () {
      var isOpen = formWrap.classList.toggle('open');
      toggleBtn.textContent = isOpen ? 'Hide ▲' : 'Reserve Mine ▼';
    });
  }

  // ─── NJ Local Pickup callout ──────────────────────────────────────
  var NJ_LOCAL_ZIPS = [
    '080', '081', '082', '083', '084', '085', '086',
    '190', '191', '193', '194',
    '197', '198', '199'
  ];
  var ZIP_STORAGE_KEY = 'ez_zip';

  function isLocalToNJ(zip) {
    if (!zip || zip.length < 3) return false;
    return NJ_LOCAL_ZIPS.indexOf(zip.substring(0, 3)) > -1;
  }

  function isDST(d) {
    var jan = new Date(d.getFullYear(), 0, 1).getTimezoneOffset();
    var jul = new Date(d.getFullYear(), 6, 1).getTimezoneOffset();
    return Math.min(jan, jul) === d.getTimezoneOffset();
  }

  function getETNow() {
    var now = new Date();
    var utc = now.getTime() + now.getTimezoneOffset() * 60000;
    var offset = isDST(now) ? -4 : -5;
    return new Date(utc + 3600000 * offset);
  }

  function getSameDayWord(etNow) {
    var day  = etNow.getDay();
    var hour = etNow.getHours();
    if (day === 0) return 'Monday';
    if (day === 6 && hour >= 12) return 'Monday';
    return 'today';
  }

  function checkLocalPickup(zip) {
    var nj = (window.ezTradeExclusiveData || {}).njPickup;
    if (!nj || !nj.available || !nj.pickUpEnabled || !isLocalToNJ(zip)) return;

    var el = document.getElementById('tradePickupCallout');
    if (!el) return;

    var time = nj.pickUpTime || '';
    var isSameDay = time.toLowerCase().indexOf('hour') > -1;

    var iconSvg =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;">' +
        '<path d="M20 6L9 17l-5-5"></path>' +
      '</svg>';

    if (isSameDay) {
      var dayWord = getSameDayWord(getETNow());
      el.innerHTML = iconSvg +
        '<span><strong>Pick up ' + dayWord + '</strong> in ' +
        '<button type="button" class="ez-pickup-link">Williamstown, NJ</button></span>';
    } else {
      el.innerHTML = iconSvg +
        '<span><strong>Pickup at </strong>' +
        '<button type="button" class="ez-pickup-link">Williamstown, NJ</button> &mdash; ' + time + '</span>';
    }
    el.classList.add('visible');

    var pickupLink = el.querySelector('.ez-pickup-link');
    if (pickupLink) {
      pickupLink.addEventListener('click', function () {
        if (window.ezPickupDrawer) window.ezPickupDrawer.open();
      });
    }
  }

  var cachedZip = sessionStorage.getItem(ZIP_STORAGE_KEY);
  if (cachedZip) {
    checkLocalPickup(cachedZip);
  } else {
    fetch('https://ipapi.co/json/')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d.postal) {
          sessionStorage.setItem(ZIP_STORAGE_KEY, d.postal);
          checkLocalPickup(d.postal);
        }
      })
      .catch(function () {});
  }
})();